import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MIN_WIDTH, MD } from "constants/vp-sizes";
export const StyledProductFeaturesTable = styled.div`
  display: flex;
  flex-direction: column;
  .toggle {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 0;
    svg {
      margin-left: 8px;
      height: 12px;
      width: 12px;
      transition: all 0.5s;
    }
    &.expanded {
      margin-bottom: ${({ isNewPricing })=>isNewPricing ? '64px' : 'inherit'};
      svg {
        transform: rotate(-180deg);
      }
    }
    &.crm-classic {
      gap: 16px;
      h2 {
        font-family: var(--brand-font-family);
        font-weight: 600;
        font-size: 24px;
        line-height: 30px;
        letter-spacing: -0.1px;
        color: #323338;
        margin: 0;
      }
      svg {
        margin-left: 0;
        height: 20px;
        width: 20px;
      }
    }
  }
  .grid {
    grid-template-columns: ${({ numberOfTiers })=>`1.6fr repeat(${numberOfTiers},1fr)`};
    display: grid;
    column-gap: 24px;
    .feature-value,
    .tier-header {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 16px 0;
      &.tier-header {
        background-color: white;
        position: sticky;
        top: 73px;
        display: flex;
        flex-direction: column;
        z-index: 2;
        .tier-title {
          font-size: ${({ isNewPricing })=>isNewPricing ? "20px" : "1rem"};
          font-weight: 600;
          margin-bottom: 4px;
          ${({ isNewPricing })=>isNewPricing && `
            display: flex;
            flex-direction: column;
            gap: 8px;
            align-items: center;
          `}
        }
        .tier-credits {
          font-size: 0.75rem;
          color: #676879;
          margin-bottom: 12px;
          width: 100%;
          text-align: center;
          min-height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;

          .credits-select {
            width: 100%;
          }
        }
      }
      .bold {
        font-weight: 600;
      }
      .tier-cta {
        position: sticky;
        top: 72px;
        .ladda-button,
        .signup-button,
        .cta-button {
          padding: 12px ${({ isNewPricing })=>isNewPricing ? "43px" : "24px"};
          background-color: transparent;
          border: 1px solid black;
          color: black;
          letter-spacing: 0.4px;
          font-size: 16px;
          &:hover {
            border-color: transparent;
            background-color: ${({ isNewPricing })=>isNewPricing ? "#323338" : "var(--primary-color)"};
            color: white;
          }
        }
      }
    }
    .product-section-header {
      display: flex;
      align-items: center;
      grid-column: 1 / 3;
      margin-bottom: 18px;

      .icon-container {
        text-align: left;
        justify-content: flex-start;
        display: flex;
        border-radius: 12px;
        width: 38px;
        height: 38px;
        justify-content: center;
        align-items: center;
        padding: 6px;
        background-color: var(--logo-color);
        &.monday-logo-container {
          background-color: transparent;
          padding: 0;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
      .product-name {
        margin-left: 8px;
        font-size: 16px;
        &.monday-product-name {
          font-weight: 700;
        }
      }
    }
  }

  @media (min-width: ${TABLET_QUERY_MIN_WIDTH}) and (max-width: ${MD}px) {
    .grid {
      column-gap: 12px;

      .tier-header {
        .tier-title {
          font-size: 1rem;
        }

        .tier-cta {
          .ladda-button,
          .signup-button,
          .cta-button {
            padding-left: 16px;
            padding-right: 16px;
            font-size: 14px;
            white-space: nowrap;
          }
        }
      }

      .product-section-header .icon-container {
        flex-shrink: 0;
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    /* This table is not meant to be shown on smaller screens.
            Until an alternative display is designed - if that happens - we just hide it altogether. */
    display: none;
  }
`;
